import { render } from "./Encuestas.vue?vue&type=template&id=2a994683"
import script from "./Encuestas.vue?vue&type=script&lang=js"
export * from "./Encuestas.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__